import { useCallback, useEffect, useState } from 'react'

import { TeamMemberRole } from '@api'
import { useUnit } from 'effector-react'
import Countdown from 'react-countdown'

import CloseIcon from '@/assets/icons/icon-close.svg'
import { $account } from '@/models/account.ts'
import { TimeBox } from '@/modules/black-friday/ui/components/TimeBox.tsx'
import {
  isBlackFridayOfferRunning,
  maxBlackFridayOfferTime,
} from '@/modules/licenses/components/dialogs/special-offer-dialog.tsx'
import { useTheme } from '@/utils/useTheme.tsx'

export const BlackFridayBanner = () => {
  const account = useUnit($account)
  const [show, setShow] = useState(true)
  const { setBlackFridayBannerOpen } = useTheme()

  useEffect(() => {
    if (isBlackFridayOfferRunning() && show) {
      setBlackFridayBannerOpen(true)
    } else {
      setBlackFridayBannerOpen(false)
    }
  }, [setBlackFridayBannerOpen, show])

  const handleCloseClick = useCallback(() => {
    setShow(false)
  }, [])

  if (
    !show ||
    !isBlackFridayOfferRunning() ||
    account?.memberRole !== TeamMemberRole.LEADER
  ) {
    return null
  }

  return (
    <div className="bg-secondary-900 fixed top-0 z-10 flex h-[64px] w-full items-center px-4 py-2">
      <div className="flex flex-1 flex-col items-center justify-center md:flex-row">
        <p className="text-center text-sm font-medium text-white">
          Cyber Monday Special:{' '}
          <span
            className="text-primary-600 cursor-pointer"
            onClick={() =>
              document.dispatchEvent(new CustomEvent('special-offer'))
            }
          >
            Enjoy 50% Off on All New Licenses and Upgrades!
          </span>
        </p>
        <Countdown
          intervalDelay={1000}
          autoStart
          date={maxBlackFridayOfferTime}
          renderer={(left) => {
            return (
              <div className="ml-4 hidden items-center md:flex lg:ml-4">
                <TimeBox
                  type="hr"
                  left={left.formatted.hours}
                />
                <TimeBox
                  type="min"
                  left={left.formatted.minutes}
                />
                <TimeBox
                  type="sec"
                  left={left.formatted.seconds}
                />
              </div>
            )
          }}
        />
      </div>
      <CloseIcon
        onClick={handleCloseClick}
        className="ml-4 mr-0 h-5 w-5 cursor-pointer group-hover:opacity-80 md:ml-8 md:mr-8"
      />
    </div>
  )
}
